<!-- 上传图片 -->
<template>
  <div>
    <b-container>
      <b-row>
        <b-col cols="10" class="mx-auto">
          <b-card-body class="text-center"><h5></h5></b-card-body>
        </b-col>
      </b-row>
      <!-- 动物 -->
      <b-row>
        <b-col cols="10" class="mx-auto">
          <b-card no-body class="overflow-hidden mt-2" @click="toUploadCard">
            <b-row no-gutters>
              <b-col md="12" class="mx-auto">
                <van-swipe :autoplay="3000" indicator-color="white">
                  <van-swipe-item
                    v-for="(item, index) in imgList_dongwu"
                    :key="index"
                  >
                    <img :src="item" />
                  </van-swipe-item>
                </van-swipe>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-card-body class="text-center"> Pet </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <!-- 科技 -->
      <b-row>
        <b-col cols="10" class="mx-auto">
          <b-card no-body class="overflow-hidden mt-2" @click="toUploadCard">
            <b-row no-gutters>
              <b-col md="12" class="mx-auto">
                <van-swipe :autoplay="3000" indicator-color="white">
                  <van-swipe-item
                    v-for="(item, index) in imgList_keji"
                    :key="index"
                  >
                    <img :src="item" />
                  </van-swipe-item>
                </van-swipe>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-card-body class="text-center">
                  Science and technology
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <!-- 风景 -->
      <b-row>
        <b-col cols="10" class="mx-auto">
          <b-card no-body class="overflow-hidden mt-2" @click="toUploadCard">
            <b-row no-gutters>
              <b-col md="12" class="mx-auto">
                <van-swipe :autoplay="3000" indicator-color="white">
                  <van-swipe-item
                    v-for="(item, index) in imgList_fengjing"
                    :key="index"
                  >
                    <img :src="item" />
                  </van-swipe-item>
                </van-swipe>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-card-body class="text-center"> View </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <!-- 植物 -->
      <b-row>
        <b-col cols="10" class="mx-auto">
          <b-card no-body class="overflow-hidden mt-2" @click="toUploadCard">
            <b-row no-gutters>
              <b-col md="12" class="mx-auto">
                <van-swipe :autoplay="3000" indicator-color="white">
                  <van-swipe-item
                    v-for="(item, index) in imgList_zhiwu"
                    :key="index"
                    :data-index="index"
                  >
                    <img :src="item" />
                  </van-swipe-item>
                </van-swipe>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-card-body class="text-center"> Plant </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "select_card",
  data() {
    return {
      name: "",
      mobile: "",
      imgList_dongwu: [
        "static/DubaiDIY/宠物/公司展会DIY卡-05.png",
        "static/DubaiDIY/宠物/公司展会DIY卡-12.png",
      ],
      imgList_fengjing: [
        "static/DubaiDIY/风景/公司展会DIY卡-03.png",
        "static/DubaiDIY/风景/公司展会DIY卡-07.png",
        "static/DubaiDIY/风景/公司展会DIY卡-09.png",
        "static/DubaiDIY/风景/公司展会DIY卡-13.png",
      ],
      imgList_keji: [
        "static/DubaiDIY/科技/公司展会DIY卡-15.png",
        "static/DubaiDIY/科技/公司展会DIY卡-17.png",
        "static/DubaiDIY/科技/公司展会DIY卡-18.png",
        "static/DubaiDIY/科技/公司展会DIY卡-10.png",
        "static/DubaiDIY/科技/公司展会DIY卡-11.png",
        "static/DubaiDIY/科技/公司展会DIY卡-14.png",
      ],
      imgList_zhiwu: [
        "static/DubaiDIY/植物/公司展会DIY卡-06.png",
        "static/DubaiDIY/植物/公司展会DIY卡-08.png",
      ],
      swiperOptions: {},
    };
  },
  watch: {},
  methods: {
    toUploadCard(event) {
      var Image = event.target;
      var resImg = this.imgToBase64(Image);
      // console.log(resImg);
      this.toUploadCardface(resImg);
    },
    toUploadCardface(img) {
      this.$router.replace({
        name: "UploadCardface_Dubai",
        params: {
          targetImg: img,
          name: this.name,
          mobile: this.mobile,
          status: "1",
        },
      });
    },
    imgToBase64(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight);
      var dataURL = canvas.toDataURL("image/png", 0.8);
      return dataURL;
    },
  },
  mounted: function () {
    this.name = this.$route.query.name;
    this.mobile = this.$route.query.mobile;
  },
};
</script>

<style scoped>
img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/DubaiCard/select_card.vue